export const statusesTranslate: Record<string, string> = {
  // Общие для Order и Withdrawal
  BN: 'Новая заявка',
  IP: 'В процессе',
  UR: 'Заявка с перерасчетом',
  ID: 'Спор',
  SF: 'Завершена успешно',
  AA: 'Автоматически одобрена',
  AAD: 'Автоматически одобрена из диспута',
  FR: 'Завершена с перерасчетом',
  NF: 'Реквизит не найден',
  TO: 'Просроченные',
  CR: 'Перерасчет отклонен',
  CANCELED: 'Отказ',

  // Только для Withdrawal
  STS: 'Отправлена в поддержку',
  PC: 'Проблема подтверждена',
  STSD: 'Спор отправлен в поддержку',
};
